import React, { forwardRef, useState } from 'react'
import Accordion from '../../../../components/Accordion/Accordion'
import Buttons from '../../../../components/ui/button/Buttons'
import { AccountInformationData } from './AccountInformation.data'
import FormCreator from '../../../../components/Forms/FormCreator'
import SwalAlert from '../../../../services/swalService/SwalService'
import { useAddReinstatementToNewApplicationbyAdminMutation, useAdminSelectReinstatementMutation, useLazyGetAnalyticsInfomrationByCorporateMemberIdQuery, useLazyGetOptExpiryOrOptTerminationByIdQuery, useLazyGetReinstateMentButtonActiveQuery, useSaveOptExpiryOrOptTerminationByAdminMutation } from '../../../../app/services/corporateMembership/corporateMemberApi'
import { useEffect } from 'react'
import { useParams, useRoutes } from 'react-router-dom'
import { decryptAESID } from '../../../../utils/Encryption'
import ToastService from '../../../../services/toastService/ToastService'
import CenterModel from '../../../../components/ui/centerModel/CenterModel'
import { handleConditionBaseFields, includesValueNormalized } from '../AccountInformation/Utils/AccountInformationUtils'


const AccountInformation = forwardRef((props, ref) => {
  const [formData, setFormData] = useState(AccountInformationData)
  const { id } = useParams();
  const editID = id ? decryptAESID(id, false) : 0
  const { error, success, confirm } = SwalAlert();
  const [isReinstateActive, setIsReinstateActive] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [adminSelectReinstatement, { data: adminSelectReinstatementData, isLoading: adminSelectReinstatementLoading, isFetching: adminSelectReinstatementFetching }] = useAdminSelectReinstatementMutation();
  const [getOptExpiryOrOptTerminationById, { data: optExpiryOrOptTerminationData, isLoading: optExpiryOrOptTerminationLoading, isSuccess: optExpiryOrOptTerminationSuccess }] = useLazyGetOptExpiryOrOptTerminationByIdQuery();
  const [saveOptExpiryOrOptTerminationByAdmin, { isSuccess: IsSuccess, isLoading: IsLoading, data: Data, isError: isError }] = useSaveOptExpiryOrOptTerminationByAdminMutation();
  const [getReinstateMentButtonActive, { data: reinstateMentButtonActiveData, isLoading: reinstateMentButtonActiveLoading, isSuccess: reinstateMentButtonActiveSuccess }] = useLazyGetReinstateMentButtonActiveQuery();
  const [addReinstatementToNewApplicationbyAdmin, { isSuccess: isAddReinstatementSuccess, isLoading: isAddReinstatementLoading, data: addReinstatementData, isError: isAddReinstatementError }] = useAddReinstatementToNewApplicationbyAdminMutation();
  const [getAnalyticsInformation, { data: getAnalyticsInformationResponse }] = useLazyGetAnalyticsInfomrationByCorporateMemberIdQuery();

  const buttonClick = () => setShowModal(true);


  const handleSubmit = () => {
    const formData = ref.current.getFormData();
    if (!formData) {
      error("Please fill in all mandatory fields to continue.", "");
      return;
    }
    let req = {
      IsOptOutExpiry: formData?.isOptOutExpiry,
      IsOptOutTermination: formData?.isOptOutTermination,
      SGBCCorporateMemberId: editID,
      MultiDomain: formData?.domainInfo
    }
    saveOptExpiryOrOptTerminationByAdmin(req);
  }

  const hadleReinstatementButton = () => {
    let req = {
      sGBCCorporateMemberId: editID
    }
    confirm("Confirm", "Confirm reinstatement?", "Yes", "Cancel").then(
      (value) => {
        if (value) {
          adminSelectReinstatement(req)
        }
      }
    );

  }

  const hadlenewApplicationButton = () => {
    let req = {
      memberId: editID
    }
    confirm("Confirm", "Confirm new application?", "Yes", "Cancel").then(
      (value) => {
        if (value) {
          addReinstatementToNewApplicationbyAdmin(req);
        }
      }
    );

  }

  useEffect(() => {
    if (id) {
      getOptExpiryOrOptTerminationById(editID);
      getReinstateMentButtonActive(editID);
      getAnalyticsInformation(editID)
    }
  }, [id])

  useEffect(() => {
    if (!adminSelectReinstatementLoading && adminSelectReinstatementData) {
      // ToastService.success("Member has been enabled for reinstatement.");
      ToastService.success(addReinstatementData?.errorMessage.includes("Member is already allowed for reinstatement.") ? addReinstatementData?.errorMessage : "Member has been enabled for reinstatement.");
    }
  }, [adminSelectReinstatementLoading, adminSelectReinstatementData]);

  useEffect(() => {
    if (!isAddReinstatementLoading && addReinstatementData) {
      ToastService.success(addReinstatementData?.errorMessage);
    }
  }, [isAddReinstatementLoading, addReinstatementData]);


  useEffect(() => {
    if (!IsLoading && IsSuccess && Data) {
      ToastService.success("Your Request Submitted successfully.", "Successful");
    }
  }, [IsLoading, IsSuccess, Data]);

  useEffect(() => {
    if (!optExpiryOrOptTerminationLoading && optExpiryOrOptTerminationSuccess && optExpiryOrOptTerminationData) {
      let form = { ...formData };
      form = {
        ...form,
        initialState: {
          ...form.initialState,
          isOptOutExpiry: optExpiryOrOptTerminationData?.isOptOutExpiry,
          isOptOutTermination: optExpiryOrOptTerminationData?.isOptOutTermination,
          membershipStatus: optExpiryOrOptTerminationData?.subscriptionStatusId,
          membershipType: optExpiryOrOptTerminationData?.membershipTypeId,
          discontinuedReason: optExpiryOrOptTerminationData?.discontinueReasonId,
          OtherDiscontinuedReason: optExpiryOrOptTerminationData?.otherDiscontinuedReason,
          joinedDate: optExpiryOrOptTerminationData?.submissionDate,
          updatedDate: optExpiryOrOptTerminationData?.updatedAt,
          domainInfo : optExpiryOrOptTerminationData?.multiDomain
        },
      }
      setFormData(form);
    }
  }, [optExpiryOrOptTerminationLoading, optExpiryOrOptTerminationSuccess, optExpiryOrOptTerminationData]);


  useEffect(() => {
    if (!reinstateMentButtonActiveLoading && reinstateMentButtonActiveSuccess && reinstateMentButtonActiveData) {
      setIsReinstateActive(reinstateMentButtonActiveData?.isAllowToReinstatement);
    }
  }, [reinstateMentButtonActiveLoading, reinstateMentButtonActiveSuccess, reinstateMentButtonActiveData]);

 useEffect(() => {
  const selectedValue = formData?.initialState?.discontinuedReason;

  if (selectedValue !== undefined) {
    let updated = handleConditionBaseFields(
      selectedValue,
      formData,
      "OtherDiscontinuedReason",
      10
    );

    if (!includesValueNormalized(selectedValue, 10)) {
      updated = {
        ...updated,
        initialState: {
          ...updated.initialState,
          OtherReasonOfJoining: null,
        },
      };
    }

    setFormData(updated);
  }
}, [formData?.initialState?.discontinuedReason]);

  return (
    <>
      <Accordion title="Account Information" accordion={false} buttonLabel="Analytics" clickEvent={buttonClick}>
        <div className="row">
          <FormCreator ref={ref} {...formData} />
        </div>
        <div className="btn-right-side">
          <Buttons
            buttonText="Save"
            buttonTypeClassName="success-btn"
            onClick={handleSubmit}
            isLoading={IsLoading}
          />
          <Buttons
            buttonText="Reinstate"
            buttonTypeClassName="outline-btn"
            onClick={hadleReinstatementButton}
            isDisable={!isReinstateActive}
          />
          <Buttons
            buttonText="New Application"
            buttonTypeClassName="success-btn"
            onClick={hadlenewApplicationButton}
            isDisable={!isReinstateActive}
          />
        </div>
      </Accordion>
      <CenterModel
        show={showModal}
        handleClose={() => setShowModal(false)}
        modelTitle=""
      >
        <div className="analytics-report">
          <h4 className="title">Analytics for the current year</h4>
          <div className="analytics-box">
            <table className="analytics-table">
              <tbody className="analytics-table-body">
                <tr >
                  <td>Number of Active SGBP Certificates</td>
                  <td className="value">0</td>
                </tr>
                <tr>
                  <td>Number of Active SGBS Certificates</td>
                  <td className="value">0</td>
                </tr>
                <tr>
                  <td>Number of Events attended</td>
                  <td className="value">{getAnalyticsInformationResponse?.eventAttendanceCount ?? 0}</td>
                </tr>
                <tr>
                  <td>Number of GMPs in Organisation</td>
                  <td className="value">{getAnalyticsInformationResponse?.organizationGmpCount ?? 0}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </CenterModel>
    </>
  )
})

export default AccountInformation
